import React from 'react';
import { ModalHeading, ModalHeadingProps } from '../Modal/ModalHeading';

export type SidebarHeadingProps = ModalHeadingProps;

export const SidebarHeading: React.FC<SidebarHeadingProps> = (props) => <ModalHeading {...props} />;
